<template>
  <div>
    <div
      v-if="showSlider"
      class="carousel"
    >
      <a
        :class="{hide:!swiperButtonPrev}"
        class="button button-pre"
        @click="$_pre()"
      >
        <slot name="button-pre">
          <i class="icon-chevron-back" />
        </slot>
      </a>
      <!-- 監聽事件判斷 showSlider -->
      <swiper
        ref="mySwiper"
        :class="{'swiper-no-swiping':swiperNoSwiping}"
        :options="_swiperOption"
        :space-between="50"
        @swiper="onSwiper()"
        @slideChange="onSlideChange()"
      >
        <swiper-slide>
          <LvContentTabBar001
            height
            :selected-tab-id="tabsList.selectedTabId"
            :content-tabs="tabsList.tabs"
            @click="$_tabOnclick($event)"
          />
        </swiper-slide>
        <div
          slot="button-prev"
          ref="swiperButtonPrev"
          class="swiper-button-prev"
        />
        <div
          slot="button-next"
          ref="swiperButtonNext"
          class="swiper-button-next"
        />
      </swiper>
      <a
        class="button button-next"
        :class="{hide:!swiperButtonNext}"
        @click="$_next()"
      >
        <slot name="button-next">
          <i class="icon-chevron-forward" />
        </slot>
      </a>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "WsTabCarousel001",
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    tabsList: {
      type: Object,
      default() {
        return {
          //   selectedTabId: "question-list",
          //   tabs: [
          //     {
          //       id: "1",
          //       textLabel: "水污染防治",
          //     },
          //   ],
        };
      },
    },
    slidesPerView: {
      type: [Number, String],
    },
    freeMode: {
      type: Boolean,
      default: true,
    },
    mousewheel: {
      type: Boolean,
    },
    keyboard: {
      type: Boolean,
    },
    autoplay: {
      type: Object,
      default: null,
    },
    swiperNoSwiping: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      swiperButtonPrev: false,
      swiperButtonNext: false,
      showSlider: true,
      swiperOption: {
        slidesPerView: "auto",
        freeMode: true,
        mousewheel: true,
        keyboard: true,
        navigation: {
          // arrow
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper;
    },
    _swiperOption() {
      let _swiperOption = {
        slidesPerView: this.slidesPerView || "auto", //畫面一次呈現幾個物件
        freeMode: this.freeMode || false, //代表滾動後不會貼合，可以自由滑動
        mousewheel: this.mousewheel || false, //可用滑鼠的滾輪控制
        keyboard: this.keyboard || false, //可用鍵盤的左右動
        navigation: {
          // arrow
          nextEl: ".swiper-button-next", //class name
          prevEl: ".swiper-button-prev", //class name
        },
      };
      if (this.autoplay) {
        _swiperOption.autoplay = {
          //自動播放
          delay: this.autoplay.delay, //秒數(ms)
          stopOnLastSlide: this.autoplay.stopOnLastSlide, //boolean
          disableOnInteraction: this.autoplay.disableOnInteraction, //boolean,
        };
      }
      return _swiperOption;
    },
  },
  watch: {
    _swiperOption: {
      handler() {
        this.showSlider = false;
        setTimeout(() => {
          this.showSlider = true;
        }, 0);
      },
      deep: true,
    },
    "tabsList.tabs": {
      handler() {
        this.showSlider = false;
        this.swiperButtonPrev = true;
        this.swiperButtonNext = true;
        setTimeout(() => {
          this.showSlider = true;
          setTimeout(() => {
            this.$_fetchButton();
          }, 0);
        }, 0);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    $_fetchButton() {
      if (
        !this.$refs.swiperButtonNext ||
        !this.$refs.swiperButtonNext.classList.length ||
        !this.$refs.swiperButtonPrev ||
        !this.$refs.swiperButtonPrev.classList.length
      )
        return;
      this.swiperButtonPrev = true;
      this.swiperButtonNext = true;
      this.$nextTick(() => {
        this.$refs.swiperButtonPrev.classList.forEach((e) => {
          if (e === "swiper-button-disabled") {
            this.swiperButtonPrev = false;
          }
        });
        this.$refs.swiperButtonNext.classList.forEach((e) => {
          if (e === "swiper-button-disabled") {
            this.swiperButtonNext = false;
          }
        });
      });
    },
    $_pre() {
      this.$_fetchButton();
      this.$refs.swiperButtonPrev.click();
    },
    $_next() {
      this.$_fetchButton();
      this.$refs.swiperButtonNext.click();
    },
    onSwiper(swiper) {
      console.log(swiper);
    },
    onSlideChange() {
      console.log("slide change");
    },
    $_tabOnclick(tab) {
      this.tabsList.selectedTabId = tab.id;
      this.$emit("tab-click", tab);
    },
  },
};
</script>
<style lang="scss" scoped>
.carousel {
  display: flex;
  .button {
    color: var(--blue-500);
    font-size: 2rem;
  }
  .swiper-container {
    width: 100%;
    height: 50px;
    .swiper-slide {
      text-align: center;
      line-height: 50px;
      width: auto;

      a {
        display: inline-block;
        padding: 0 15px;
        text-decoration: none;
        color: #474747;
        &:hover {
          color: black;
        }
      }
    }
    .swiper-button-disabled {
      visibility: hidden;
    }
    .swiper-button-next,
    .swiper-button-prev {
      @include flex_center;
      width: 36px;
      height: 36px;
      padding: 6px;
      border: solid 1px var(--blue-500);
      border-radius: 50%;
      background-color: white;
      opacity: 0;
      &:after {
        font-size: 0.875rem;
        font-weight: bold;
        color: var(--blue-500);
      }
    }
  }
  a {
    i {
      line-height: 50px;
    }
  }
  .hide {
    visibility: hidden;
  }
}
</style>